

export const PROJECT_LOADING = 'PROJECT_LOADING';
export const SET_DIMENSIONS = 'SET_DIMENSIONS';
